module.exports = __webpack_public_path__ + "static/media/process_2.5e997649.svg";